import { useContext } from 'react';
import { createContext } from 'react';

import { ResponsiveLayoutMobileProps } from '../@types/ResponsiveLayoutMobileProps';

export const ResponsiveLayoutMobileContext = createContext<ResponsiveLayoutMobileProps>(
	{} as ResponsiveLayoutMobileProps,
);

ResponsiveLayoutMobileContext.displayName = 'ResponsiveLayoutMobile';

const ResponsiveLayoutMobileProvider = (props: ResponsiveLayoutMobileProps) => (
	<ResponsiveLayoutMobileContext.Provider value={props}>{props.children}</ResponsiveLayoutMobileContext.Provider>
);

export const useResponsiveLayoutMobile = () => {
	const context = useContext(ResponsiveLayoutMobileContext);

	return context;
};

export default ResponsiveLayoutMobileProvider;
